/**
 * Copyright (C) IRT GmbH 2020
 */

var EventEmitter = require('events');

var _KeyEvent = require('../tools/keyevent_constants');

var Storage = require('../tools/local-storage');

var createElement = require('../tools/functions').createElement;

/**
 * @returns {TextPage}
 *
 * @param {Element} domelem Parent HTMLElement used to render the TextPage
 * @param {Object} opt
 */
function TextPage(domelem, opt, placeHolders) {

    placeHolders = placeHolders || {};

    var focussed = "textarea";

    var emitter = new EventEmitter();

    if (!domelem)
        throw "TextPage: Invalid arguments";

    var textPage = createElement(domelem, "div", "textPage");
    createElement(textPage, "div", "title", replacePlaceholders(opt.title));

    var outerArea = createElement(textPage, "div", "outerArea");
    var textArea = createElement(outerArea, "div", "textArea");

    for (var x in opt.text) {
        var textBlock = opt.text[x];

        createElement(textArea, "div", "hl1", replacePlaceholders(textBlock.headline));
        var firstLineAsSubHeadline = (textBlock.subheadlines === true);

        //var par =  textArea.appendChild(document.createElement("p"));
        for (var y in textBlock.paragraphs) {
            var paragraph = textBlock.paragraphs[y];
            for (var z in paragraph) {
                var parElem = paragraph[z];
                if (firstLineAsSubHeadline && z == 0) {
                    createElement(textArea, "div", "hl2", replacePlaceholders(parElem));
                } else if (typeof parElem == "string") {
                    createElement(textArea, "div", "par", replacePlaceholders(parElem));
                } else if (typeof parElem.list != "undefined") {
                    var list = createElement(textArea, "ul", "line");
                    for (var z2 in parElem.list) {
                        createElement(list, "li", null, replacePlaceholders(parElem.list[z2]));
                    }
                } else if (Array.isArray(parElem)) {
                    var par3 = createElement(textArea, "div", "par");
                    for (var z3 in parElem) {
                        createElement(par3, "div", "line", replacePlaceholders(parElem[z3]));
                    }
                }
            }
        }
    }
    var settings = createElement(outerArea, "div", "textArea");
    createElement(settings, "div", "hl1", replacePlaceholders(opt.settings.headline));
    for (x in opt.settings.infotext) {
        createElement(settings, "div", "par", replacePlaceholders(opt.settings.infotext[x]));
    }

    var tracker = opt.settings.tracker;
    for (x in tracker) {
        tracker[x].element = createElement(settings, "div", "cookie-selector");
        createElement(tracker[x].element, "span", "icon", "&#160;");
        createElement(tracker[x].element, "span", "text", opt.settings.tracker[x].title);
        checkOptOut(tracker[x]);
    }

    var closeButton = createElement(textPage, "a", "clickButton", opt.closeButton);

    show(false);
    selectTextArea(true);

    /**
     * @param {string} str
     * @returns {string}
     */
    function replacePlaceholders (str) {
        for (x in placeHolders) {
            str = str.replace(x, placeHolders[x]);
        }
        return str;
    }

    /**
     * @param {boolean} visible make FAQ elem visible or hidden
     */
    function show (visible) {
        if (textPage) {
            textPage.style.display = visible ? "block" : "none";
            document[visible ? "addEventListener" : "removeEventListener"]("keydown", keyhandler, false);
        }
    }

    function keyhandler (e) {
        switch (e.keyCode) {
            case e.VK_UP: case _KeyEvent.VK_UP:
                up();
                break;
            case e.VK_DOWN: case _KeyEvent.VK_DOWN:
                down();
                break;
            case e.VK_LEFT: case _KeyEvent.VK_LEFT:
                left();
                break;
            case e.VK_RIGHT: case _KeyEvent.VK_RIGHT:
                right();
                break;
            case e.VK_ENTER: case _KeyEvent.VK_ENTER:
                onEnter();
                break;
            case e.VK_BACK: case _KeyEvent.VK_BACK:
                closeTextPage();
            default:
                return;
        }
        e.preventDefault();
    }

    function closeTextPage () {
        show(false);
        emitter.emit('close');
    }

    function onEnter() {
        switch (focussed) {
        case "closebutton":
            closeTextPage();
            break;
        case "tracker":
            setOptOut(tracker[0], !checkOptOut(tracker[0]));
            break;
        }
    }

    function setOptOut(tracker, b) {
        if (b) {
            Storage.set(tracker.storageId, tracker.storageId);
        } else {
            Storage.remove(tracker.storageId);
        }
        checkOptOut(tracker);
    }

    function checkOptOut(tracker) {
        if (Storage.get(tracker.storageId) !== null) {
            tracker.element.classList.add("opted-out");
            return true;
        } else {
            tracker.element.classList.remove("opted-out");
            return false;
        }
    }

    function selectTextArea(b) {
        textArea.classList[b ? "add" : "remove"]("focussed");
        if (b) focussed = "textarea";
    }

    function selectClose (b) {
        closeButton.classList[b ? "add" : "remove"]("selected");
        if (b) focussed = "closebutton";
    }

    function selectTracker (tracker, b) {
        //console.log (tracker, b);
        tracker.element.classList[b ? "add" : "remove"]("focussed");
        if (b) focussed = "tracker";
    }

    function down () {
        switch (focussed) {
            case "textarea":
                textArea.scrollBy(0, opt.scrollSteps);
                break;
            case "tracker":
                selectTracker(tracker[0], false);
                selectClose(true);
                break;
        }
    }

    function up () {
        switch (focussed) {
            case "textarea":
                textArea.scrollBy(0, -opt.scrollSteps);
                break;
            case "closebutton":
                selectClose(false);
                selectTracker(tracker[0], true);
                break;
        }
    }

    function right() {
        switch (focussed) {
            case "textarea":
                selectTextArea(false);
                selectTracker(tracker[0], true);
                break;
            case "tracker":
                selectTracker(tracker[0], false);
                selectClose(true);
                break;
        }
    }

    function left() {
        switch (focussed) {
            case "tracker":
                selectTracker(tracker[0], false);
                selectTextArea(true);
                break;
            case "closebutton":
                selectClose(false);
                selectTracker(tracker[0], true);
                break;
        }
    }

    return {
        /**
         * Shows and hides the FAQPage
         */
        show : show,
        on : emitter.on.bind(emitter),
        off : emitter.removeListener.bind(emitter),
        once : emitter.once.bind(emitter)
    };
}

module.exports = TextPage;
